import axios from 'axios'
import { formatAxiosError } from './apiErrors'
const URL = 'https://rentalios-management-helxajom3a-uc.a.run.app/api'
// const URL = "http://localhost:3000/api"
const apiKey = 'db31a33d-9efb-4112-a246-6e60cbd779a8'

async function getHousemates({
  page = 1,
  perPage = 10,
  time = 'active',
  sort = '',
  sortBy = '',
  searchValue = '',
  propertyIds = ''
}) {
  try {
    const response = await axios({
      method: 'GET',
      url: `${URL}/rental/in/full/${page}/${perPage}/${time}`,
      params: {
        key: apiKey,
        sort: sort,
        sortMethod: sortBy,
        search: searchValue,
        propertyId: propertyIds
      }
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return { error: formatAxiosError(error) }
  }
}

export default {
  getHousemates
}
